import React from "react";
import Icon from "@ant-design/icons";

const AddMemberSvg = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="40"
    height="40"
    fill="none"
    viewBox="0 0 40 40"
  >
    <circle cx="20" cy="20" r="20" fill="#F0F5FA"></circle>
    <path
      fill="#165ABF"
      d="M20 19.667c1.513 0 2.784-1.34 2.784-3.073 0-1.692-1.285-2.99-2.784-2.99-1.505 0-2.79 1.319-2.79 3.004.008 1.719 1.278 3.059 2.79 3.059zm-.006 1.222a6.79 6.79 0 00-2.942.65 4.534 4.534 0 011.623 3.459c0 .373-.049.746-.145 1.091h5.773c1.132 0 1.526-.345 1.526-.98 0-1.775-2.251-4.22-5.835-4.22zm-5.863 7.672c1.933 0 3.563-1.616 3.563-3.563 0-1.948-1.609-3.556-3.563-3.556-1.948 0-3.557 1.608-3.557 3.556 0 1.954 1.61 3.563 3.557 3.563zm-2.252-3.563c-.006-.283.187-.47.47-.47h1.312v-1.305c0-.283.187-.476.47-.476.29 0 .476.193.476.476v1.305h1.305c.283 0 .477.187.477.47 0 .29-.194.476-.477.476h-1.305v1.313c0 .283-.186.47-.476.47-.284 0-.47-.187-.47-.47v-1.313H12.35c-.276 0-.47-.186-.47-.476z"
    ></path>
  </svg>
);

const AddMemberIcon = (props) => <Icon component={AddMemberSvg} {...props} />;

export { AddMemberIcon };
